import { useInfiniteQuery } from "@tanstack/react-query";
import { useNavigationState } from "@/zustand/NavigationState";
import { listRecordings } from "@/server/services/recordingService";

/**
 * Loads a GROUP chat's recordings with cursor pagination (`nextBefore`).
 *
 * `enabled` MUST reflect the moderator gate applied by the caller — the backend
 * 403s a non-moderator, so we never fire the request for one. The query is also
 * gated on `showChatDetails` (mirrors `usePaginatedMembersByChatId`) so it only
 * runs while the details panel is open.
 */
export function useRecordings(chatId: string | null, enabled: boolean) {
  const showChatDetails = useNavigationState((state) => state.showChatDetails);

  return useInfiniteQuery({
    queryKey: ["chat-recordings", chatId],
    queryFn: async ({ pageParam }) =>
      listRecordings(chatId as string, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextBefore ?? undefined,
    enabled: enabled && !!chatId && showChatDetails,
    refetchOnReconnect: true,
  });
}
